import { Globe } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useConfig } from "./ConfiguracoesLayout";
import ConfigSection, { inputClass } from "./ConfigSection";

const AnalyticsConfig = () => {
  const { form, update } = useConfig();

  return (
    <ConfigSection title="Analytics & Pixel" icon={Globe}>
      <p className="text-sm text-muted-foreground mb-4">
        Configure o rastreamento de conversões no seu cardápio digital. Eventos como <strong>adicionar ao carrinho</strong>, <strong>iniciar checkout</strong> e <strong>compra</strong> serão disparados automaticamente.
      </p>
      <div className="space-y-4">
        <div className="space-y-2">
          <Label>Google Analytics 4 — Measurement ID</Label>
          <Input
            value={form.ga_measurement_id}
            onChange={(e) => update("ga_measurement_id", e.target.value)}
            className={inputClass}
            placeholder="G-XXXXXXXXXX"
          />
          <p className="text-xs text-muted-foreground">
            Encontre em Google Analytics → Admin → Data Streams → Measurement ID
          </p>
        </div>
        <div className="space-y-2">
          <Label>Meta Pixel ID</Label>
          <Input
            value={form.meta_pixel_id}
            onChange={(e) => update("meta_pixel_id", e.target.value)}
            className={inputClass}
            placeholder="123456789012345"
          />
          <p className="text-xs text-muted-foreground">
            Encontre em Meta Events Manager → Fontes de Dados → Pixel ID
          </p>
        </div>
      </div>
    </ConfigSection>
  );
};

export default AnalyticsConfig;
